import { render } from "./ProductDialog.vue?vue&type=template&id=23bdef00&scoped=true&ts=true"
import script from "./ProductDialog.vue?vue&type=script&lang=ts"
export * from "./ProductDialog.vue?vue&type=script&lang=ts"

import "./ProductDialog.vue?vue&type=style&index=0&id=23bdef00&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23bdef00"]])

export default __exports__